import { useEffect, useState } from "react";
import { Users, Box, Fingerprint, Building2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAtt } from "./AttendanceLayout";
import { CapacityBar } from "@/components/attendance/CentersAdmin";

export function PageTitle({ title, crumb }) {
  return (
    <div className="flex items-center justify-between mb-6 page-title">
      <h1 className="font-display text-2xl font-bold text-slate-900">{title}</h1>
      <p className="text-sm text-slate-500 print-hide">Home <span className="mx-1">›</span> <span className="text-slate-900">{crumb || title}</span></p>
    </div>
  );
}

export default function AttDashboard() {
  const { isAdmin } = useAtt();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/attendance/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  const cards = [
    ["Total Capacity", s?.capacity, Building2, "capacity"], ["Enrolled Candidates", s?.enrolled, Users, "candidates"],
    ["Remaining Seats", s?.remaining, Users, "remaining"], ["Active Batches", s?.active_batches, Box, "batches"],
    ["Fingerprints Enrolled", s?.fingerprints, Fingerprint, "fingerprints"], ...(isAdmin ? [["Centers", s?.centers, Building2, "centers"]] : []),
  ];
  const pct = s?.capacity ? (s.enrolled / s.capacity) * 100 : 0;
  return (
    <div>
      <PageTitle title="Dashboard" />
      {s && pct >= 100 && <div data-testid="capacity-alert" className="mb-4 rounded-xl bg-red-50 border border-red-200 text-red-700 px-4 py-3 text-sm font-medium">Center enrollment capacity is full.</div>}
      {s && pct >= 80 && pct < 100 && <div data-testid="capacity-alert" className="mb-4 rounded-xl bg-amber-50 border border-amber-200 text-amber-800 px-4 py-3 text-sm font-medium">Center capacity is nearing its limit.</div>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map(([label, val, Icon, id]) => (
          <div key={label} className="bg-white rounded-2xl border border-slate-200 p-6" data-testid={`stat-${id}`}>
            <span className="w-12 h-12 rounded-xl bg-slate-100 text-slate-700 flex items-center justify-center mb-6"><Icon className="w-5 h-5" /></span>
            <p className="text-sm text-slate-500">{label}</p>
            <p className="font-display text-4xl font-bold text-slate-900 mt-1">{val ?? "—"}</p>
          </div>
        ))}
      </div>
      {s && (
        <div className="grid lg:grid-cols-2 gap-5 mt-6">
          <div className="bg-white rounded-2xl border border-slate-200 p-6" data-testid="capacity-progress"><h2 className="font-semibold text-slate-900 mb-3">Capacity Progress</h2><CapacityBar enrolled={s.enrolled} max={s.capacity} /></div>
          <div className="bg-white rounded-2xl border border-slate-200 p-6" data-testid="batch-counts"><h2 className="font-semibold text-slate-900 mb-3">Batch-wise Candidates</h2>
            {s.batch_counts.length === 0 ? <p className="text-sm text-slate-500">No active batches.</p> : <ul className="divide-y divide-slate-100">{s.batch_counts.map((b) => <li key={b.id} className="flex justify-between py-2 text-sm"><span className="text-slate-700">{b.name}</span><b>{b.count}</b></li>)}</ul>}
          </div>
        </div>
      )}
    </div>
  );
}
